// components/Nav.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

const NAV_LINKS = [
  { label: "MUSIC",   href: "https://portal.syncmama.com/" },
  { label: "SOUNDFX", href: "https://portal.syncmama.com/sfx" },
  { label: "NOW OUT", href: "https://portal.syncmama.com/new-inspiration" },
  { label: "LABELS",  href: "https://portal.syncmama.com/catalogs" },
  { label: "PRICING", href: "#pricing" },
  { label: "ABOUT", href: "/about", internal: true },
];

export default function Nav({ dark, onToggleDark }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <nav className={`
      fixed top-0 left-0 right-0 z-[100] h-16 px-[6%]
      flex items-center justify-between
      transition-all duration-[400ms] ease-[cubic-bezier(.4,0,.2,1)]
      ${scrolled
        ? "bg-white/95 dark:bg-[#0d1117]/95 backdrop-blur-2xl border-b border-[rgba(27,58,107,0.1)] dark:border-[rgba(255,255,255,0.08)] shadow-[0_2px_24px_rgba(27,58,107,0.1)]"
        : "bg-transparent"
      }
    `}>
      {/* Logo */}
      <a
        href="/"
        className="font-syne text-[21px] font-extrabold tracking-[-0.5px] text-navy dark:text-[#e6edf3] no-underline z-10"
      >
        SYNC<span className="text-pink">MAMA</span>
      </a>

      {/* Links */}
      <div className="flex items-center gap-7">
        {NAV_LINKS.map(({ label, href, internal }) => (
          <a
            key={label}
            href={href}
            className="
              hidden sm:block
              text-[#5a6888] dark:text-[#8b949e] no-underline
              text-[13.5px] font-medium font-dm
              relative
              after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:right-0
              after:h-[1.5px] after:bg-pink after:scale-x-0 after:origin-left
              after:transition-transform after:duration-250
              hover:text-navy dark:hover:text-[#e6edf3] hover:after:scale-x-100
            "
          >
            {label}
          </a>
        ))}

        {/* Dark mode toggle */}
        <button
          onClick={onToggleDark}
          aria-label="Toggle dark mode"
          className="
            p-1 rounded text-[#5a6888] dark:text-[#8b949e]
            hover:text-navy dark:hover:text-[#e6edf3]
            transition-colors duration-200 bg-transparent border-none cursor-pointer
          "
        >
          {dark
            ? <LightModeIcon sx={{ fontSize: 20 }} />
            : <DarkModeIcon  sx={{ fontSize: 20 }} />
          }
        </button>

        {/* CTA */}
        <a
          href="https://portal.syncmama.com/login"
          className="nav-cta"
        >
          Sign In
        </a>
      </div>
    </nav>
  );
}
